// Do not edit directly
// Generated on Tue, 11 Jan 2022 15:30:21 GMT
// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace DesignTokens {
  export enum BorderRadiusEnum {

    B16 = '16px',

    B40 = '40px',

    Circle = '50%',

    Small = '2px',

    Medium = '4px',

    Large = '8px'
  }
  export enum BorderStyleEnum {
    /**
      * Common border-width
      */
    Width = '1px'
  }
  export interface Destination {
    /**
      * ### #0069FF
      * InSided brand color
      * ![#0069FF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%230069FF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Brand: '#0069FF'
    /**
      * ### #2B3346
      * InSided secondary brand color
      * ![#2B3346](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%232B3346%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    SecondaryBrand: '#2B3346'
    /**
      * ### rgba(0, 0, 0, .2)
      * InSided button border color
      * ![rgba(0, 0, 0, .2)](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22rgba(0%2C%200%2C%200%2C%20.2)%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    BrandBorderColor: 'rgba(0, 0, 0, .2)'
    /**
      * ### #AB2692
      * Customization toolbar button color
      * ![#AB2692](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23AB2692%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Purple: '#AB2692'
    /**
      * ### #FFFFFF
      * White for destination
      * ![#FFFFFF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFFFFF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    White: '#FFFFFF'
    Grey: {
    /**
      * ### #9599A2
      * Unnamed color, name it!
      * ![#9599A2](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%239599A2%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      5: '#9599A2'
      /**
      * ### #D5D6DA
      * Unnamed color, name it!
      * ![#D5D6DA](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23D5D6DA%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      20: '#D5D6DA'
      /**
      * ### #BFC2C8
      * Unnamed color, name it!
      * ![#BFC2C8](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23BFC2C8%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      30: '#BFC2C8'
    }
    Font: {
    /**
      * Default font family for InSided Destination environment
      */
      Family: "Roboto, 'Helvetica Neue', Helvetica, Arial, sans-serif"
    }
  }
  export interface Control {
    Grey: {
    /**
      * ### #333333
      * Color for normal text and icons
      * ![#333333](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23333333%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      1: '#333333'
      /**
      * ### #878787
      * Color for subtitle, metadata
      * ![#878787](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23878787%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      2: '#878787'
      /**
      * ### #C5C5C5
      * Color for border
      * ![#C5C5C5](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23C5C5C5%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      3: '#C5C5C5'
      /**
      * ### #E8E8E8
      * Color for background of pills (editable tabs)
      * ![#E8E8E8](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23E8E8E8%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      4: '#E8E8E8'
      /**
      * ### #F8F8F8
      * Color for background, section header or footer
      * ![#F8F8F8](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23F8F8F8%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      5: '#F8F8F8'
      /**
      * ### #D5D6DA
      * Unnamed color, name it!
      * ![#D5D6DA](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23D5D6DA%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      20: '#D5D6DA'
    }
    /**
      * ### #D9604C
      * Color for error message, background color of button 'danger'
      * ![#D9604C](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23D9604C%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Red: '#D9604C'
    /**
      * ### #A2D14E
      * Color for success message, background color of button 'Save Changes'
      * ![#A2D14E](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23A2D14E%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Green: '#A2D14E'
    /**
      * ### #4DABF7
      * Color for links, active status
      * ![#4DABF7](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%234DABF7%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Blue: '#4DABF7'
    /**
      * ### #EDF9FE
      *
      * ![#EDF9FE](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23EDF9FE%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    LightBlue: '#EDF9FE'
    /**
      * ### #9B59B6
      *
      * ![#9B59B6](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%239B59B6%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Purple: '#9B59B6'
    /**
      * Color for overlay when there is a pop-up
      */
    PopUpOverlay: 'transparentize(#000000, 0.9)'
    /**
      * Color for control button border
      */
    ButtonBorder: 'transparentize(#000000, 0.8)'
    /**
      * ### #FFFFFF
      * Unnamed color, name it!
      * ![#FFFFFF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFFFFF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    White: '#FFFFFF'
    Color: {
    /**
      * ### #F4F5F6
      * Unnamed color, name it!
      * ![#F4F5F6](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23F4F5F6%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey5: '#F4F5F6'
      /**
      * ### #EAEBED
      * Unnamed color, name it!
      * ![#EAEBED](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23EAEBED%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey10: '#EAEBED'
      /**
      * ### #D5D6DA
      * Unnamed color, name it!
      * ![#D5D6DA](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23D5D6DA%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey20: '#D5D6DA'
      /**
      * ### #9599A2
      * Unnamed color, name it!
      * ![#9599A2](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%239599A2%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey50: '#9599A2'
      /**
      * ### #6B707E
      * Unnamed color, name it!
      * ![#6B707E](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%236B707E%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey70: '#6B707E'
      /**
      * ### #555C6B
      * Unnamed color, name it!
      * ![#555C6B](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23555C6B%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey80: '#555C6B'
      /**
      * ### #2B3346
      * Unnamed color, name it!
      * ![#2B3346](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%232B3346%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Grey100: '#2B3346'
      /**
      * ### #F2F8FF
      * Unnamed color, name it!
      * ![#F2F8FF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23F2F8FF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Blue5: '#F2F8FF'
      /**
      * ### #FFF6F6
      * Unnamed color, name it!
      * ![#FFF6F6](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFF6F6%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Red5: '#FFF6F6'
      /**
      * ### #FFDE99
      * Unnamed color, name it!
      * ![#FFDE99](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFDE99%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Orange40: '#FFDE99'
    }
    Font: {
    /**
      * Default font family for InSided Control environment
      */
      FamilyDefault: "'Helvetica Neue', Helvetica, Arial, sans-serif"
      /**
      * Font family for code in InSided Control environment
      */
      FamilyCode: 'Monospace'
    }
  }
  export interface Control2 {
    /**
      * ### #0069FF
      * Primary actions, buttons and links
      * ![#0069FF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%230069FF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Blue: '#0069FF'

    BlueDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #0069FF'

    BlueLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #0069FF'

    Blue1: 'linear-gradient(0deg, rgba(0, 105, 255, 0.1), rgba(0, 105, 255, 0.1)), #FFFFFF'

    Blue2: 'linear-gradient(0deg, rgba(0, 105, 255, 0.2), rgba(0, 105, 255, 0.2)), #FFFFFF'

    Blue3: 'linear-gradient(0deg, rgba(0, 105, 255, 0.3), rgba(0, 105, 255, 0.3)), #FFFFFF'

    Blue4: 'linear-gradient(0deg, rgba(0, 105, 255, 0.4), rgba(0, 105, 255, 0.4)), #FFFFFF'

    Blue5: 'linear-gradient(0deg, rgba(0, 105, 255, 0.5), rgba(0, 105, 255, 0.5)), #FFFFFF'

    Blue6: 'linear-gradient(0deg, rgba(0, 105, 255, 0.6), rgba(0, 105, 255, 0.6)), #FFFFFF'

    Blue7: 'linear-gradient(0deg, rgba(0, 105, 255, 0.7), rgba(0, 105, 255, 0.7)), #FFFFFF'

    Blue8: 'linear-gradient(0deg, rgba(0, 105, 255, 0.8), rgba(0, 105, 255, 0.8)), #FFFFFF'

    Blue9: 'linear-gradient(0deg, rgba(0, 105, 255, 0.9), rgba(0, 105, 255, 0.9)), #FFFFFF'
    /**
      * ### #2B3346
      * Unnamed color, name it!
      * ![#2B3346](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%232B3346%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Black: '#2B3346'
    Grey: {

      5: 'linear-gradient(0deg, rgba(43, 51, 70, 0.05), rgba(43, 51, 70, 0.05)), #FFFFFF'

      10: 'linear-gradient(0deg, rgba(43, 51, 70, 0.1), rgba(43, 51, 70, 0.1)), #FFFFFF'

      20: 'linear-gradient(0deg, rgba(43, 51, 70, 0.2), rgba(43, 51, 70, 0.2)), #FFFFFF'

      40: 'linear-gradient(0deg, rgba(43, 51, 70, 0.5), rgba(43, 51, 70, 0.5)), #FFFFFF'

      60: 'linear-gradient(0deg, rgba(43, 51, 70, 0.6), rgba(43, 51, 70, 0.6)), #FFFFFF;'

      70: 'linear-gradient(0deg, rgba(43, 51, 70, 0.6), rgba(43, 51, 70, 0.7)), #FFFFFF;'

      80: 'linear-gradient(0deg, rgba(43, 51, 70, 0.8), rgba(43, 51, 70, 0.8)), #FFFFFF'
    }
    /**
      * ### #FFAC00
      * Warning
      * ![#FFAC00](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFAC00%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Orange: '#FFAC00'

    OrangeDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #FFAC00'

    OrangeLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #FFAC00'
    /**
      * ### #24C25E
      * Success
      * ![#24C25E](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%2324C25E%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Green: '#24C25E'
    Secondary: {
    /**
      * ### #F4FCF7
      * Background for success panels or callouts
      * ![#F4FCF7](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23F4FCF7%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Green5: '#F4FCF7'
      /**
      * ### #A7E7BF
      * Background for success panels or callouts
      * ![#A7E7BF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23A7E7BF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Green40: '#A7E7BF'
      /**
      * ### #FFFBF2
      * Background for success panels or callouts
      * ![#FFFBF2](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFFBF2%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Orange5: '#FFFBF2'
      /**
      * ### #FFDE99
      * Background for success panels or callouts
      * ![#FFDE99](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFDE99%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      Orange40: '#FFDE99'
    }

    GreenDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #24C25E'

    GreenLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #24C25E'
    /**
      * ### #FB4E4E
      * Error
      * ![#FB4E4E](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FB4E4E%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Red: '#FB4E4E'

    RedDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #FB4E4E'

    RedLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #FB4E4E'
    /**
      * ### #B730A1
      * Unnamed color, name it!
      * ![#B730A1](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23B730A1%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Purple: '#B730A1'

    PurpleDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #B730A1'

    PurpleLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #B730A1'
    /**
      * ### #FF2B60
      * Unnamed color, name it!
      * ![#FF2B60](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FF2B60%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Pink: '#FF2B60'

    PinkDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #FF2B60'

    PinkLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #FF2B60'
    /**
      * ### #52B9FF
      * Unnamed color, name it!
      * ![#52B9FF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%2352B9FF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    LightBlue: '#52B9FF'

    LightBlueDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #52B9FF'

    LightBlueLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #52B9FF'
    /**
      * ### #322C74
      * Unnamed color, name it!
      * ![#322C74](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23322C74%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
    Dark: '#322C74'

    DarkDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #322C74'

    DarkLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #322C74'

    Yellow: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #322C74'

    YellowDark: 'linear-gradient(0deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)), #FFD000'

    YellowLight: 'linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), #FFD000'
  }
  export interface Insided {
    Blue: {
    /**
      * ### #CCE1FF
      * Unnamed color, name it!
      * ![#CCE1FF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23CCE1FF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      20: '#CCE1FF'
      /**
      * ### #005EE6
      * Unnamed color, name it!
      * ![#005EE6](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23005EE6%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      110: '#005EE6'
    }
    Green: {
    /**
      * ### #D3F3DF
      * Unnamed color, name it!
      * ![#D3F3DF](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23D3F3DF%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      20: '#D3F3DF'
    }
    Red: {
    /**
      * ### #FFF6F6
      * Unnamed color, name it!
      * ![#FFF6F6](data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2010%202%22%3E%3Crect%20fill%3D%22%23FFF6F6%22%20width%3D%2210%22%20height%3D%222%22%20rx%3D%220.1%22%2F%3E%3C%2Fsvg%3E)
      */
      5: '#FFF6F6'
    }
  }
  export enum ShadowEnum {
    /**
      * Use for clickable elements, e.g. cards, sections, etc
      */
    CardDefault = ' 0px 1px 2px rgba(0, 0, 0, 0.16)',
    /**
      * Use for hover status for clickable elements, e.g. cards, sections, etc
      */
    CardHover = '0px 2px 4px rgba(0, 0, 0, 0.16)',
    /**
      * Use for modal like pop-up
      */
    Modal = '0px 0px 16px rgba(0, 0, 0, 0.08)',
    /**
      * Use for dropdown
      */
    CardDropdown = '0px 1px 4px rgba(0, 0, 0, 0.16)',
    /**
      * Use for dropdown
      */
    Dropdown = '0 1px 4px rgba(0, 0, 0, 0.24)'
  }
  export enum SpacingEnum {

    S4 = '4px',

    S8 = '8px',

    S12 = '12px',

    S16 = '16px',

    S20 = '20px',

    S24 = '24px',

    S32 = '32px',

    S64 = '64px'
  }
  export interface Font {
    Size: {

      10: '10px'
      /**
      * Font size for regular text
      */
      12: '12px'

      14: '14px'
      /**
      * Font size for smaller heading e.g. pop-up heading
      */
      16: '16px'
      /**
      * Font size for smaller heading e.g. pop-up heading
      */
      20: '20px'
      /**
      * Font size for heading, e.g. page header
      */
      24: '24px'
      /**
      * Font size for heading, e.g. page header
      */
      32: '32px'
    }
    Weight: {

      500: 500
      /**
      * Font weight for headings, highlighted text in InSided Control environment
      */
      Bold: 700
      /**
      * Font weight for regular text in InSided Control environment
      */
      Regular: 400
    }
  }
  export enum LineHeightEnum {
    /**
      * Unitless heading line-heights for reusability
      */
    Heading = 1.25,
    /**
      * Unitless text line-heights for reusability
      */
    Text = 1.5,
    /**
      * Unitless line-heights for reusability
      */
    Reset = 1
  }
  export enum ZIndexEnum {

    Toast = 10000,

    Modal = 9000,

    Overlay = 8000,

    Dropdown = 7000,

    Dialog = 6000,

    Popup = 5000,

    HomepageWidgets = 4000,

    Sticky = 100,

    Docked = 4,

    Default = 1
  }
}
